const route = Object.freeze({
  LANDING: '/landing',
  WELCOME: '/welcome',
  CHANNEL: '/channel',
  RADIO: '/radio',
  TIME: '/time',
  WEATHER: '/weather',
  PORTAL: '/portal',
  NEWS: '/news',
  SETTINGS: '/settings',
  Casting: '/casting',
  HDMI: '/hdmi',
  SOURCE: '/source',
  Youtube: '/youtube',
  Netflix: '/netflix',
  Internet: '/internet',
  PrimeVideo: '/primevideo',
  DEVICEIPNOTFOUND: '/device_ip/notfound',
  NOTFOUND: '/404',
  LOADING: '/loading',
});

const obj = { route };

export default obj;
